import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { useMutationQuestionImportWooclap } from 'gql/mutations/question';
import extract from 'helpers/extract';
import { trackEvent, reportError } from 'lib/tracking';

import QuestionImportWooclap from './QuestionImportWooclap';

const QuestionImportWooclapContainer = ({ course, handleModalClose }) => {
  const { t } = useTranslation();
  const mutationQuestionImportWooclap = useMutationQuestionImportWooclap();
  const [status, setStatus] = useState(undefined);
  const [chapterId, setChapterId] = useState(null);
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        chapterId: yup
          .string()
          .nullable()
          .transform((v) => v || null)
          .trim()
          .uuid(),
      }),
    [],
  );
  const handleWooclapOpen = useCallback(
    async (values) => {
      try {
        setStatus(undefined);
        const { chapterId: cId } = extract(values, validationSchema);
        setChapterId(cId);
        const popup = window.open('/', 'Wooclap', 'height=700,width=800');
        if (popup) {
          popup.location.href = 'about:blank';
          popup.location.href =
            'https://app.wooclap.com/user/questions/export-to-wooflash';
        }
      } catch (err) {
        setStatus('500');
      }
    },
    [validationSchema],
  );
  const handleMessage = useCallback(
    async (message) => {
      try {
        const {
          origin,
          data: { event, payload },
        } = message;
        if (
          origin !== 'https://app.wooclap.com' ||
          event !== 'WooflashMessage.IMPORT'
        ) {
          return;
        }
        const {
          data: { questionImportWooclap },
        } = await mutationQuestionImportWooclap({
          courseId: course.id,
          chapterId,
          payload,
        });
        handleModalClose(questionImportWooclap);
        trackEvent('question', 'import-wooclap');
      } catch (err) {
        setStatus('500');
        reportError('question', 'import-wooclap', err);
      }
    },
    [chapterId, course, handleModalClose, mutationQuestionImportWooclap],
  );
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
  return (
    <QuestionImportWooclap
      chapters={course.chapters}
      handleWooclapOpen={handleWooclapOpen}
      status={status}
      t={t}
      validationSchema={validationSchema}
    />
  );
};

QuestionImportWooclapContainer.propTypes = {
  course: PropTypes.object.isRequired,
  handleModalClose: PropTypes.func.isRequired,
};

export default QuestionImportWooclapContainer;
